const { VITE_API_ROOT, VITE_SOCKET_URL } = import.meta.env;

const config = {
  API_ROOT: VITE_API_ROOT,
  SOCKET_URL: VITE_SOCKET_URL,
  DEFAULT_LANGUAGE: "ru",
  CATEGORY_PRODUCT: 1,
  CATEGORY_MATERIAL: 2,
  CATEGORY_FINISHED: 3,
  CATEGORY_HALF_FINISHED: 4,
  CATEGORY_DISH: 5,
  CATEGORY_TELEGRAM: 6,
  CATEGORY_STORE: 10,
  TRANSACTION_TYPE_INCOME: 1,
  TRANSACTION_TYPE_EXPENSE: 2,
  USER_TYPE_SYSTEM: 1,
  USER_TYPE_PROVIDER: 2,
  USER_TYPE_CLIENT: 3,
  USER_TYPE_OTHERS: 4,
  ORDER_STATUS_COMPLETED: 20,
  API_LANGUAGES: [
    { id: 1, code: "uz", title: "Узбекча" },
    { id: 2, code: "ru", title: "Русский" },
  ],
  CURRENCY_TYPES: [
    { title: "сум", label: "UZS", code: "uzs" },
    { title: "$", label: "USD", code: "usd" },
    { title: "€", label: "EUR", code: "eur" },
    { title: "рубль", label: "RUB", code: "rub" },
    { title: "тенге", label: "KZT", code: "kzt" },
    { title: "dirxam", label: "AED", code: "aed" },
    { title: "сомони", label: "TJS", code: "tjs" },
    { title: "SOM", label: "KGS", code: "kgs" },
    { title: "lira", label: "TRY", code: "try" },
    { title: "₨", label: "PKR", code: "pkr" },
  ],
};
export default config;
